import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { translate } from 'helpers/translateHelper';
import { TextArea, Switch } from 'sharedComponents';
import { commentTextMaxLength, maxSubjectCount } from './constants';
import TrendCommentsModalFieldError from './TrendCommentsModalFieldError';

const TrendCommentsModalCommentFields = ({ formData, errors, handleChange, showVisibilityToggle }) => {
    return (
        <>
            <Col className='subject-input-col'>
                <label>
                    {translate('ABB.Powertrain.Frontend.opTrendCommentsModalSubjectLabel')}
                    <span className='character-count'>
                        {formData.subject.length}/{maxSubjectCount}
                    </span>
                </label>
                <input
                    type='text'
                    className={`subject-input ${errors.subject ? 'error' : ''}`}
                    value={formData.subject}
                    onChange={(e) => handleChange('subject', e.target.value)}
                    placeholder={translate('ABB.Powertrain.Frontend.opTrendCommentsModalInputLabel')}
                />
                <TrendCommentsModalFieldError message={errors.subject} />
            </Col>
            <Col className='comment-col'>
                <label>
                    {translate('ABB.Powertrain.Frontend.opTrendCommentsModalAcceptBtn')}
                    <span className='character-count'>
                        {formData.comment.length}/{commentTextMaxLength}
                    </span>
                </label>
                <TextArea
                    className={`comment-textarea ${errors.comment ? 'error' : ''}`}
                    resizable={true}
                    onChange={(value) => handleChange('comment', value)}
                    value={formData.comment}
                    placeholder={translate('ABB.Powertrain.Frontend.opTrendCommentsModalInputLabel')}
                />
                <TrendCommentsModalFieldError message={errors.comment} />
            </Col>
            {showVisibilityToggle &&
                <Col className='comment-switch-btn'>
                    <Switch
                        className='me-2'
                        checked={formData.isPublic}
                        onChange={(checked) => handleChange('isPublic', checked)}
                    />
                    <span>
                        {translate('ABB.Powertrain.Frontend.opTrendCommentsModalPublicLabel')}
                    </span>
                </Col>
            }
        </>
    );
};

TrendCommentsModalCommentFields.propTypes = {
    formData: PropTypes.object,
    errors: PropTypes.object,
    handleChange: PropTypes.func,
    showVisibilityToggle: PropTypes.bool
};

export default TrendCommentsModalCommentFields;
